module.exports = __webpack_public_path__ + "static/media/bulgarian-embassy.ca099ba8.jpg";